
import firebase from "firebase/compat/app"
import "firebase/compat/storage"
import "firebase/compat/firestore"

export const app = firebase.initializeApp ({
  apiKey: "AIzaSyDpI5obNWOmD1UFjfAB2BYamMWPK6DvRVU",
  authDomain: "hardspace-4753a.firebaseapp.com",
  projectId: "hardspace-4753a",
  storageBucket: "hardspace-4753a.appspot.com",
  messagingSenderId: "593245386292",
  appId: "1:593245386292:web:f5b24244e5f69b8d8efc61",
  measurementId: "G-XBN57HNQFS"
});

